import Vue from 'vue';
import i18n from "@utils/i18n";
import VueGtag, { pageview } from 'vue-gtag';
import VeeValidate from 'vee-validate';
import VueRouter from 'vue-router';
import veeConfig from '@config/veeValidate.js';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import GlobalOptions from 'vue-global-options';
import 'url-search-params-polyfill';

import sanitize from '@utils/sanitize';
import Portal from './Portal.vue';

import store from './store';
import createRouter from "./router";

Vue.use(VueRouter);
Vue.use(VeeValidate, {
  ...veeConfig,
  i18n
});
Vue.use(GlobalOptions, ['sanitize', 'baseUrl', 'studySlug']);

export function init(selector, options, props) {

  store.commit('SET_OPTIONS', options);

  // set localStorage ['Enrollment-Extra'] the url search params
  if (window.localStorage && window.location.search) {
    const searchParams = new URLSearchParams(window.location.search);

    const current = window.localStorage.getItem('Enrollment-Extra') || '{}';
    let extraParams = JSON.parse(current);
    for(const [key, value] of searchParams) {
      extraParams[key] = value;
    }

    window.localStorage.setItem("Enrollment-Extra", JSON.stringify(extraParams));
  }

  if (options.initLocale) {
    i18n.locale = options.initLocale;
    // set local storage
    if (window.localStorage) {
      window.localStorage.setItem('ppt_locale', options.initLocale);
    }
  }

  const router = createRouter(`${options.baseUrl}/${options.slug}`);

  if (options.gTag) {
    Vue.use(VueGtag, {
      config: {
        id: options.gTag,
        params: {
          language: i18n.locale,
          send_page_view: false // don't call a pageview when library is initially propped up
        }
      },
      pageTrackerTemplate(to) {
        return {
          page_title: to.name,
          page_path: to.path,
          page_location: document.location.href,
          user_id: store.getters.getParticipant ? store.getters.getParticipant.id : null,
        }
      },
      onReady() {
        // the pageview sent at library instantiation wasn't using our template above
        // so it was missing stuff. Do it manually here for the page load,
        // the library will handle any route changes normally using the above template.
        router.onReady(() => {
          const to = router.currentRoute;
          pageview({
            page_title: to.name,
            page_path: to.path,
            page_location: document.location.href,
            user_id: store.getters.getParticipant ? store.getters.getParticipant.id : null
          });
        });
      }
    }, router);
  }

  return new Vue({
    el: selector,
    sanitize: sanitize,
    baseUrl: options.baseUrl,
    studySlug: options.slug,
    router,
    store,
    i18n,
    render(h) {
      return h(Portal, {
        props: props
      });
    }
  });
}
